
/* injects from baggage-loader */
require('./balloon-payment.component.html');

import angular from 'angular';

angular.module('AaApp.Opp').component('balloonPayment', {
    templateUrl: '/app/components/deal-sheet/contract/balloon-payment.component.html',
    bindings: {
        value: '<'
    }
});
